import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/components/Reveal";

const FAQS = [
  {
    q: "When does the cohort start?",
    a: "The first cohort starts Tuesday, November 3, 2026. We'll meet once a week for 8 weeks, with the exact call time shared before we begin.",
  },
  {
    q: "Who is The Embodied Creator for?",
    a: "It's for creators, entrepreneurs, and business owners who have something they want to share but need clarity, structure, and support to actually build it. You don't need to have everything figured out—you just need to be ready to show up and do the work.",
  },
  {
    q: "Do I need an audience already?",
    a: "No. You can join with a small audience or no audience at all; we'll focus on building a clear message and content foundation that you can grow from.",
  },
  {
    q: "How much time does it take each week?",
    a: "Plan for roughly 3–5 hours per week, including the live call and the work you'll do between sessions. The more you put into it, the more you'll get out of it.",
  },
  {
    q: "What happens after I apply?",
    a: "I'll personally review your application and reach out within 48 hours. If it feels like a good fit, we'll connect briefly before you officially enroll.",
  },
  {
    q: "Do you guarantee results?",
    a: "No. I don't guarantee specific followers, revenue, clients, or other outcomes. I provide the strategy, structure, tools, and support—the results depend on what you do with them.",
  },
  {
    q: "What does 'embodied' actually mean?",
    a: "It means we don't just work on what you need to do—we work on who you need to become to actually do it. We'll work with the fear, perfectionism, self-doubt, and resistance that can keep you from being seen, creating consistently, and putting your work out into the world.",
  },
];

export const Faq = () => (
  <section
    id="faq"
    className="bg-bone py-24 lg:py-32"
    data-testid="faq-section"
  >
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <Reveal>
        <div className="text-center">
          <Eyebrow light>What is the Embodied Creator?</Eyebrow>
          <h2 className="mt-6 font-mont text-3xl font-bold leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Asked <em className="italic text-forest">honestly</em>, answered
            the same way.
          </h2>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-14">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-ink/10"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger className="py-6 text-left font-mont text-lg font-bold text-ink hover:no-underline sm:text-xl [&>svg]:text-forest">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-[#5c5c5c] sm:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
